import React from 'react';
import { HeaderLayout } from '@layouts';
import { Grid } from '@mui/material';

export default function EditProduct() {
  return (
    <HeaderLayout>
      <Grid container justify="space-between" />
    </HeaderLayout>
  );
}
